// https://matthiashager.com/converting-snake-case-to-camel-case-object-keys-with-javascript
export default function toCamel(s) {
  return s.toLowerCase().replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace("-", "").replace("_", "");
  });
}
